const BetOfferScorer = {
  title: 'Example JSON',
  expectedOutput: 'Full Time (Feyenoord Outcome Criterion)',
  initialDisplayedCode: `{
  "outcomeId": 2950948554,
  "betOffer": {
    "id": 2385741730, 
    "betOfferType": {
      "id": 17, `,
  moreCode: `
      "name": "Scorer"  
    },
    "criterion": {
      "label": "Full Time"
    },
    "outcomes": [
      {
          "id": 2950948551,
          "criterion": {
          "name": "Arsenal Outcome Criterion"
          }
      },{
          "id": 2950948554,
          "criterion": {
          "name": "Feyenoord Outcome Criterion"
          }
      }
    ]
   },
   "event": {
      "id": 1018562026,
      "tags": ["MATCH"]
    }
}`,
};

export default BetOfferScorer;
